class TouchManger {
  constructor(initiator) {
    this.initiator = initiator;
    this.pressed = false;
    this.point = { x: 0, y: 0 };

    this.touchStartHandler = (event) => { this.down(event); };
    this.touchEndHandler = (event) => { this.end(event); };
    this.touchCancelHandler = (event) => { this.cancel(event); };
    this.touchMoveHandler = (event) => { this.move(event); };
  }

  addEvents() {
    this.initiator.DOMElement.addEventListener('touchstart', this.touchStartHandler);
    this.initiator.DOMElement.addEventListener('touchend', this.touchStartHandler);
    this.initiator.DOMElement.addEventListener('touchcancel', this.touchStartHandler);
    this.initiator.DOMElement.addEventListener('touchmove', this.touchMoveHandler);
  }

  removeEvents() {
    this.initiator.DOMElement.removeEventListener('touchstart', this.touchStartHandler);
    this.initiator.DOMElement.removeEventListener('touchend', this.touchStartHandler);
    this.initiator.DOMElement.removeEventListener('touchcancel', this.touchStartHandler);
    this.initiator.DOMElement.removeEventListener('touchmove', this.touchStartHandler);
  }

  down() {
    this.pressed = true;
  }

  up() {
    this.pressed = false;
  }

  cancel() {
    this.pressed = false;
  }

  move(event) {
    if (!this.pressed) return;
    this.initiator.point = { x: event.touches[0].clientX, y: event.touches[0].clientY };
  }
}

export default TouchManger;
